<template>
    <x-quick-action-button title="Hapus"
        icon="trash"
        :disabled="disabled"
        color="danger"
        @click="handleClick" />
</template>

<script>
import XQuickActionButton from './XQuickActionButton.vue'
export default {
    components: { XQuickActionButton },
    methods: {
        handleClick(e) {
            this.$emit('click', e)
        },
    },
    props: {
        disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
    },
}
</script>